import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, LayoutDashboard, ShieldCheck } from "lucide-react";
import { BRAND } from "@/lib/brand";

const links = [
  ["How it works", "/#how"],
  ["Packages", "/#packages"],
  ["Portfolio", "/#portfolio"],
  ["Stories", "/#stories"],
];

export const Logo = ({ dark = false, full = false, className = "" }) => {
  const src = full ? BRAND.LOGO_FULL_DARK : dark ? BRAND.LOGO_URL_DARK || BRAND.LOGO_URL : BRAND.LOGO_URL;
  if (src) return <img src={src} alt={BRAND.name} className={`${full ? "w-72 h-auto" : "h-14 w-auto"} ${className}`} data-testid="brand-logo" />;
  return (
    <span className={`font-serif-display text-2xl tracking-tight ${dark ? "text-brand-cream" : "text-brand-ink"} ${className}`} data-testid="brand-logo">
      {BRAND.short}<span className="text-brand-accent italic"> Interiors</span>
    </span>
  );
};

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="no-print sticky top-0 z-50 bg-brand-ink-soft/95 backdrop-blur-md border-b border-brand-accent/30 grain relative" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo"><Logo dark /></Link>
        <nav className="hidden md:flex items-center gap-9 text-sm text-brand-line/80">
          {links.map(([l, h]) => (
            <a key={l} href={h} className="hover:text-brand-accent transition-colors" data-testid={`nav-link-${l.replace(/\s/g, "-").toLowerCase()}`}>{l}</a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              {user.role === "admin" && <Link to="/admin" className="hidden sm:flex items-center gap-2 text-sm text-brand-cream hover:text-brand-accent transition-colors" data-testid="nav-admin-link"><ShieldCheck className="w-4 h-4" /> Admin</Link>}
              <Link to="/dashboard" className="hidden sm:flex items-center gap-2 text-sm text-brand-cream hover:text-brand-accent transition-colors" data-testid="nav-dashboard-link">
                <LayoutDashboard className="w-4 h-4" /> My Quotations
              </Link>
              <button onClick={() => { logout(); nav("/"); }} className="p-2 text-brand-line/70 hover:text-brand-cream" data-testid="nav-logout-btn" aria-label="Log out">
                <LogOut className="w-4 h-4" />
              </button>
            </>
          ) : (
            <Link to="/login" className="text-sm text-brand-cream hover:text-brand-accent transition-colors" data-testid="nav-login-link">Sign in</Link>
          )}
          <Link to="/estimate" className="rounded-full bg-brand-accent text-white text-sm px-5 py-2.5 hover:bg-brand-accent-dark transition-colors duration-300" data-testid="nav-instant-quote-btn">
            Instant Quote
          </Link>
        </div>
      </div>
    </header>
  );
}
